
import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function TeamListDefaultMessage() 
{
    const { app_user } = useCTAL();
  
    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                    <p>Hi {app_user.FirstName},</p>

                    <p><b>Your Team List doesn't have any Actions yet!</b></p>

                    <p>Hopefully you are an old pro now at creating and managing Actions using your private Long List and prioritized Short List.</p>

                    <p>This Team Action List is similar to your private Long List but Actions can be pulled into any Team Member's Short List either
                       by themself or assigned by another Team Member. 
                    </p>

                    <p>Team Members can see that a Team Action is assigned you (i.e., contained in your Short List) but they will <u>not</u> be able to 
                       see any of your private Actions (those created from within your Short or Long List) or those from another Team that they are not also
                       a Team Member of (example: They can see this Team's Actions assigned to you, but not from the Volunteer Team you work with
                       in your abundant free time)
                    </p>

                    <div class="row mt-1">
                        <div class="col">
                            <a href="#"><img class="list_item_icon" src="./images/info.svg" alt="users" border="0"/></a>
                            <span class="mt-2">Click on the Information icon above for more help.</span>
                        </div>
                    </div>

                    <p></p>

                    <p>Let's get going!</p>
                </small>
            </div>
        </> 
    );
}